module.exports = __webpack_public_path__ + "img/thumb-escritorio.6b62eb40.jpg";